import { arEG } from "../../../../date-fns/locale/ar-EG.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    arEG
  }
};